module.exports = __webpack_public_path__ + "static/media/minefillServicesHero.e02f64f0.jpg";